import React from "react";
import { useNavigate } from "react-router-dom";

import { Header, Title } from "@/components";
import { PageTitles } from "@/resources/locale";
import logo from "@/assets/img/logo.svg";
import Styles from "./AboutApp.module.scss";

const APP_VERSION = process.env.REACT_APP_VERSION || "1.0.0";

export const AboutApp: React.FC = () => {
  const navigate = useNavigate();

  const handleDeveloperClick = () => {
    window.open("https://aintec.org/", "_blank");
  };

  return (
    <>
      <Header title="О приложении" />
      <main>
        <section className="container">
          <Title>О приложении</Title>
          <div className={Styles.wrapper}>
            <div className={Styles.content}>
              <div className={Styles.logoContainer}>
                <img src={logo} alt="Tennis.ru" className={Styles.logo} />
              </div>

              <h1 className={Styles.title}>Tennis.ru</h1>

              <p className={Styles.version}>Сборка {APP_VERSION}</p>

              <div className={Styles.description}>
                <p>
                  Tennis.ru - это семейный клуб, где Вы можете поиграть в большой теннис и padel.
                  Также на территории расположен фитнес-клуб с бассейном, у клуба собственная
                  охраняемая территория с просторным паркингом
                </p>
              </div>

              <div className={Styles.developer} onClick={handleDeveloperClick}>
                <p className={Styles.developerText}>Разработано компанией</p>
                <div className={Styles.developerLogo}>
                  <span className={Styles.developerName}>Aintec</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};
